const PAYMENT_PROVIDER_KEYS = new Set([
  'securepay',
  'paybridge',
  'paykumo',
  'dypay',
  's3pay',
  'copay',
  'kisspay',
  'badoo',
  'badoopay'
])

function normalizeValue(value) {
  return String(value === null || value === undefined ? '' : value).trim().toLowerCase()
}

export function isPaymentProviderBank(bank) {
  if (!bank || typeof bank !== 'object') return false
  if (bank.payment_channel === true || normalizeValue(bank.account_type) === 'payment') return true

  return [
    bank.id,
    bank.key,
    bank.bank_name,
    bank.account_no,
    bank.account_holder,
    bank.firstname,
    bank.type_deposit,
    bank.payment_provider,
    bank.deposit_source
  ].some(value => PAYMENT_PROVIDER_KEYS.has(normalizeValue(value)))
}

export function isLegacyDepositReceiverBank(bank) {
  if (!bank || isPaymentProviderBank(bank)) return false
  const bankType = normalizeValue(bank.type)
  if (!['deposit', 'both'].includes(bankType)) return false
  if (bankType === 'both' && normalizeValue(bank.type_deposit) !== 'webhook_json') return false
  return Boolean(normalizeValue(bank.bank_name) && normalizeValue(bank.account_no))
}

export function assertLegacyDepositReceiverBank(bank) {
  if (!isLegacyDepositReceiverBank(bank)) {
    const error = new Error('ช่องทางรับฝากไม่ถูกต้อง ระบบยกเลิกรายการเพื่อความปลอดภัย กรุณาทำรายการใหม่')
    error.code = 'INVALID_DEPOSIT_RECEIVER'
    throw error
  }
  return bank
}
